/* src/app/common/mpos-forms/components/mpos-select/mpos-select.component.scss */
:host {
  display: flex;
}
:host nz-form-item {
  display: flex !important;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1mb3Jtcy9jb21wb25lbnRzL21wb3Mtc2VsZWN0L21wb3Mtc2VsZWN0LmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyI6aG9zdCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICAvLyBmbGV4OiAxIDEgMCU7XG4gICAgLy8gLmFudC1zZWxlY3Qge1xuICAgIC8vICAgICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xuICAgIC8vIH1cbiAgICBuei1mb3JtLWl0ZW0ge1xuICAgICAgICBkaXNwbGF5OiBmbGV4ICFpbXBvcnRhbnQ7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbn0iXSwKICAibWFwcGluZ3MiOiAiO0FBQUE7QUFDSSxXQUFBOztBQUtBLE1BQUE7QUFDSSxXQUFBO0FBQ0EsU0FBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
